/* ==========================================================================
   Lockett Labs, Today's Offers
   Markup: sections/lockett-labs-todays-deals.liquid. Styles: assets/ll-offers.css.
   Feed:   sections/ll-deals-feed.liquid (the whole sale, 250 products a request).

     pool      every in-stock, genuinely discounted product. Starts as the 50 Liquid
               can see, becomes the full feed before the section is in view.
     profile   what this shopper is into: games, brands, types and price, from their
               orders (signed in), basket, watchlist, recent views and past clicks here
     filters   For you (when there is a profile), Biggest savings, then each game;
               the game cards above the banner drive the same filters
     card      name first, set and number under it, floored saving on a hex-nut badge,
               honest scarcity, Add to basket, watch bell
     Lockett   the living logo in the header looks at the offer being picked and
               cheers for a great one (see mode="cue" in assets/lockett-eye.min.js)

   Merchant data reaches the page through textContent only.
   ========================================================================== */
(function () {
  'use strict';

  var GAMES = {
    pokemon:   { name: 'Pokémon',     color: '#ffd43b' },
    japanese:  { name: 'Japanese',    color: '#ff6b81' },
    disney:    { name: 'Disney',      color: '#b692ff' },
    onepiece:  { name: 'One Piece',   color: '#5aa2ff' },
    magic:     { name: 'Magic',       color: '#ff5d55' },
    digimon:   { name: 'Digimon',     color: '#35dbe9' },
    accessory: { name: 'Accessories', color: '#b3c4d6' },
    other:     { name: 'More',        color: '#ef8fb3' }
  };
  var gameOf = function (vendor, type, title) {
    var x = ((type || '') + ' ' + (vendor || '')).toLowerCase();
    if (x.indexOf('accessor') > -1) return 'accessory';
    if (/japan/i.test(title || '') && x.indexOf('pok') > -1) return 'japanese';
    if (x.indexOf('pok') > -1) return 'pokemon';
    if (x.indexOf('disney') > -1 || x.indexOf('lorcana') > -1 || x.indexOf('ravensburger') > -1) return 'disney';
    if (x.indexOf('one piece') > -1 || x.indexOf('bandai') > -1 && /one piece/i.test(title || '')) return 'onepiece';
    if (x.indexOf('mtg') > -1 || x.indexOf('magic') > -1 || x.indexOf('gathering') > -1) return 'magic';
    if (x.indexOf('digimon') > -1) return 'digimon';
    return 'other';
  };

  var ls = {
    get: function (k, fb) { try { var v = JSON.parse(localStorage.getItem(k)); return v == null ? fb : v; } catch (e) { return fb; } },
    set: function (k, v) { try { localStorage.setItem(k, JSON.stringify(v)); } catch (e) {} }
  };
  var ss = {
    get: function (k) { try { return JSON.parse(sessionStorage.getItem(k)); } catch (e) { return null; } },
    set: function (k, v) { try { sessionStorage.setItem(k, JSON.stringify(v)); } catch (e) {} }
  };
  var svg = function (d, cls) {
    var s = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    s.setAttribute('viewBox', '0 0 24 24');
    s.setAttribute('aria-hidden', 'true');
    if (cls) s.setAttribute('class', cls);
    d.split('|').forEach(function (p) {
      var path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
      path.setAttribute('d', p);
      s.appendChild(path);
    });
    return s;
  };
  var el = function (tag, cls, text) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text != null) n.textContent = text;
    return n;
  };
  var I_BELL = 'M12 3.7a5.8 5.8 0 0 0-5.8 5.8c0 3.6-1.2 5-2 6h15.6c-.8-1-2-2.4-2-6A5.8 5.8 0 0 0 12 3.7Z|M9.9 18.4a2.1 2.1 0 0 0 4.2 0';
  var I_ARROW = 'M5 12h13|M13 6l6 6-6 6';
  var I_TICK = 'm6 12.5 4 4 8-8.5';
  var I_BAG = 'M5.6 8.8h12.8a1.3 1.3 0 0 1 1.29 1.42l-.73 8.05a2.6 2.6 0 0 1-2.59 2.36H8.63a2.6 2.6 0 0 1-2.59-2.36l-.73-8.05A1.3 1.3 0 0 1 5.6 8.8Z|M9 10.4V7.5a3 3 0 0 1 6 0v2.9';
  var pctOf = function (d) { return d.c > d.p ? Math.floor((d.c - d.p) * 100 / d.c) : 0; };

  /* One toast for the page, outside the slanted band so it sits level. */
  var toastEl = null, toastT = 0;
  var toast = function (msg, link) {
    if (!toastEl) {
      toastEl = el('div', 'llo-toast');
      toastEl.setAttribute('role', 'status');
      toastEl.setAttribute('aria-live', 'polite');
      document.body.appendChild(toastEl);
    }
    toastEl.textContent = '';
    toastEl.appendChild(el('span', null, msg));
    if (link) {
      var a = el('a', null, link.text);
      a.href = link.href;
      toastEl.appendChild(a);
    }
    toastEl.classList.remove('is-in');
    void toastEl.offsetWidth;
    toastEl.classList.add('is-in');
    clearTimeout(toastT);
    toastT = setTimeout(function () { toastEl.classList.remove('is-in'); }, 3200);
  };

  function Offers(root) {
    this.root = root;
    var d = root.dataset;
    this.max = parseInt(d.max, 10) || 12;
    this.hot = parseInt(d.hot, 10) || 30;
    this.personal = d.personalize === 'true';
    this.vary = d.vary === 'true';
    this.rotate = d.rotate === 'true';
    this.perGame = parseInt(d.perGame, 10) || 3;
    this.explore = isNaN(parseInt(d.explore, 10)) ? 2 : parseInt(d.explore, 10);
    this.live = d.live === 'true';
    this.showWas = d.showWas !== 'false';
    this.showSave = d.showSave !== 'false';
    this.feedUrl = d.feed || '/collections/our-latest-deals';
    this.cid = d.customerId || '';
    try { this.fmt = new Intl.NumberFormat('en-GB', { style: 'currency', currency: d.currency || 'GBP' }); }
    catch (e) { this.fmt = { format: function (v) { return '£' + v.toFixed(2); } }; }

    this.rail = root.querySelector('[data-rail]');
    this.chipsBox = root.querySelector('[data-chips]');
    this.status = root.querySelector('[data-status]');
    this.foot = root.querySelector('[data-foot]');
    this.eye = root.querySelector('lockett-eye');
    this.deckCards = Array.prototype.slice.call(root.querySelectorAll('.llo-deck__card'));
    this.filter = null;
    this.touched = false;
    this.full = false;
    this.cheered = {};

    var pool = [];
    try { pool = JSON.parse((root.querySelector('[data-pool]') || {}).textContent || '[]'); } catch (e) { pool = []; }
    this.setPool(pool);
    this.buildProfile();
    this.bind();
    this.boot();
  }

  Offers.prototype.money = function (pence) { return this.fmt.format((pence || 0) / 100); };

  Offers.prototype.setPool = function (arr) {
    var seen = {};
    this.pool = arr.filter(function (d) {
      if (!d || !d.h || seen[d.h] || !(d.c > d.p)) return false;
      seen[d.h] = 1;
      d.g = gameOf(d.v, d.y, d.t);
      d.pc = pctOf(d);
      return true;
    });
    this.byHandle = {};
    var self = this;
    this.pool.forEach(function (d) { self.byHandle[d.h] = d; });
  };

  /* ---------------------------------------------------------------- profile */
  Offers.prototype.buildProfile = function () {
    var pr = this.profile = { game: {}, vendor: {}, type: {}, priceSum: 0, priceN: 0, boost: {}, sources: {} };
    var bump = function (map, key, w) {
      key = String(key || '').toLowerCase().trim();
      if (!key || key === 'null' || key === 'undefined') return;
      map[key] = (map[key] || 0) + w;
    };
    var add = function (vendor, type, title, price, w, src) {
      if (!vendor && !type) return;
      bump(pr.vendor, vendor, w);
      bump(pr.type, type, w);
      bump(pr.game, gameOf(vendor, type, title), w);
      if (price > 0) { pr.priceSum += price; pr.priceN++; }
      pr.sources[src] = 1;
    };
    this.addSignal = add;

    /* 1. Orders (signed in), rendered server-side as vendor||type||price(pence). */
    if (this.personal) {
      var raw = '';
      try { raw = JSON.parse((this.root.querySelector('[data-purchases]') || {}).textContent || '""'); } catch (e) {}
      (raw || '').split('~~').forEach(function (rec) {
        if (!rec) return;
        var p = rec.split('||');
        add(p[0], p[1], '', (parseFloat(p[2]) || 0), 3, 'orders');
      });
    }

    /* 2. Watchlist and recently viewed: flat handle lists, newest first. The
          recently-viewed section caches each product's JSON in sessionStorage. */
    var cached = function (h) {
      try { var box = JSON.parse(sessionStorage.getItem('ll_rvp_' + h)); return box && box.p ? box.p : null; } catch (e) { return null; }
    };
    var self = this;
    var feed = function (list, w, boost, src) {
      if (Object.prototype.toString.call(list) !== '[object Array]') return;
      list.slice(0, 30).forEach(function (h, i) {
        if (typeof h !== 'string' || !h) return;
        pr.boost[h] = Math.max(pr.boost[h] || 0, boost);
        var ww = w * Math.max(0.35, 1 - i * 0.06);
        var p = cached(h);
        if (p) { add(p.vendor, p.type || p.product_type, p.title, (parseFloat(p.price) || 0), ww, src); return; }
        var d = self.byHandle[h];
        if (d) add(d.v, d.y, d.t, d.p, ww, src);
      });
    };
    if (this.personal) {
      feed(ls.get('ll_watchlist', []), 4, 3, 'watchlist');
      feed(ls.get('ll_recently_viewed', []), 1.6, 0.9, 'viewed');
      /* 3. Offers opened from this section before. */
      ls.get('ll:viewed', []).slice(0, 40).forEach(function (it) {
        var age = (Date.now() - (it.ts || Date.now())) / 86400000;
        add(it.v, it.t, '', (parseFloat(it.p) || 0), Math.max(0.4, 2 - age * 0.25), 'offers');
      });
    }
    /* 4. The basket, once /cart.js has answered (kept so a rebuild keeps it). */
    (this.basket || []).forEach(function (it) { add(it.vendor, it.product_type, it.product_title, it.price, 2.5, 'basket'); });
    this.shown = {};
    var shownMap = this.shown;
    ls.get('ll:shown', []).forEach(function (h) { shownMap[h] = 1; });
  };

  Offers.prototype.hasSignal = function () {
    var g = this.profile.game;
    for (var k in g) if (g[k] > 0) return true;
    return false;
  };

  /* A number per product per day, so the daily rotation is stable all day and
     different tomorrow, whatever order the feed arrives in. */
  var dayNo = function () { var d = new Date(); return Math.floor(Date.UTC(d.getFullYear(), d.getMonth(), d.getDate()) / 86400000); };
  var hash = function (s) { var h = 2166136261; for (var i = 0; i < s.length; i++) { h ^= s.charCodeAt(i); h = Math.imul(h, 16777619); } return (h >>> 0) / 4294967296; };

  Offers.prototype.score = function (d, day) {
    var pr = this.profile, s = 0;
    var gM = this._gM, vM = this._vM, tM = this._tM;
    if (gM > 0) s += 2.6 * ((pr.game[d.g] || 0) / gM);
    if (vM > 0) s += 1.2 * ((pr.vendor[String(d.v || '').toLowerCase()] || 0) / vM);
    if (tM > 0) s += 0.8 * ((pr.type[String(d.y || '').toLowerCase()] || 0) / tM);
    if (this._avg > 0) { var r = Math.abs(d.p - this._avg) / this._avg; s += 0.9 * Math.max(0, 1 - Math.min(1, r)); }
    s += 0.9 * Math.min(1, d.pc / 60);
    if (pr.boost[d.h]) s += pr.boost[d.h];
    if (this.shown[d.h] && this.vary) s -= 1.2;
    if (this.rotate) s += 1.1 * hash(d.h + ':' + day);
    if (this.vary) s += Math.random() * 1.1;
    return s;
  };

  Offers.prototype.pick = function (filter) {
    var pr = this.profile, self = this, day = dayNo();
    var mx = function (m) { var x = 0; for (var k in m) if (m[k] > x) x = m[k]; return x; };
    this._gM = mx(pr.game); this._vM = mx(pr.vendor); this._tM = mx(pr.type);
    this._avg = pr.priceN ? pr.priceSum / pr.priceN : 0;
    var list = this.pool.slice();
    var n = this.max;

    if (filter === 'best') {
      list.sort(function (a, b) {
        return (b.pc - a.pc) || ((b.c - b.p) - (a.c - a.p)) || (hash(a.h + day) - hash(b.h + day));
      });
      return list.slice(0, n);
    }
    if (filter && GAMES[filter]) {
      list = list.filter(function (d) { return d.g === filter; });
      list.forEach(function (d) { d._s = self.score(d, day); });
      list.sort(function (a, b) { return b._s - a._s; });
      return list.slice(0, n);
    }

    /* For you / Top picks: ranked, then no more than perGame from one game, with
       a couple of surprise slots so tastes can widen. */
    list.forEach(function (d) { d._s = self.score(d, day); });
    list.sort(function (a, b) { return b._s - a._s; });
    var reserve = this.hasSignal() ? Math.min(this.explore, n - 1) : 0;
    var core = n - reserve, out = [], count = {}, used = {};
    var cap = this.hasSignal() ? this.perGame : Math.max(2, Math.ceil(n / 4));
    for (var pass = 0; pass < 2 && out.length < core; pass++) {
      for (var i = 0; i < list.length && out.length < core; i++) {
        var d = list[i];
        if (used[d.h]) continue;
        if (pass === 0 && (count[d.g] || 0) >= cap) continue;
        out.push(d); used[d.h] = 1; count[d.g] = (count[d.g] || 0) + 1;
      }
    }
    var rest = list.filter(function (d) { return !used[d.h]; });
    rest.sort(function (a, b) { return hash(a.h + ':x' + day) - hash(b.h + ':x' + day); });
    for (var j = 0; j < rest.length && out.length < n; j++) out.push(rest[j]);
    return out;
  };

  /* ------------------------------------------------------------------ cards */
  Offers.prototype.card = function (d) {
    var self = this;
    var li = el('li', 'llo-card' + (d.pc >= this.hot ? ' is-great' : ''));
    li.setAttribute('data-h', d.h);

    var name = d.t, set = '';
    if (d.s && d.t.indexOf(' : ') > -1) {
      name = d.t.split(' : ')[0].trim();
      set = d.t.slice(d.t.indexOf(' : ') + 3).replace(/ - /g, ' · ').trim();
    }
    var url = '/products/' + d.h;

    var well = el('div', 'llo-card__well');
    var ia = el('a', 'llo-card__img');
    ia.href = url; ia.tabIndex = -1; ia.setAttribute('aria-hidden', 'true');
    if (d.i) {
      var img = document.createElement('img');
      img.alt = ''; img.loading = 'lazy'; img.decoding = 'async'; img.width = 360; img.height = 360;
      img.src = d.i;
      ia.appendChild(img);
    }
    well.appendChild(ia);

    /* Type tags (IR, Promo, Booster box, JP) come down with the record as
       markup from snippets/ll-type-tags, the same Liquid that draws them on
       every other card, so this file never has its own idea of a rarity. The
       markup is the store's own and escaped there. */
    if (d.k) {
      var tt = el('span', 'llo-card__tt');
      tt.innerHTML = d.k;
      well.appendChild(tt);
    }

    /* The saving sits on a hex nut, the bolt from the logo. It turns when the
       card is picked, and turns further for a great offer. */
    var hex = el('span', 'llo-hex');
    var nut = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    nut.setAttribute('viewBox', '-50 -50 100 100');
    nut.setAttribute('class', 'llo-hex__nut');
    nut.setAttribute('aria-hidden', 'true');
    var poly = document.createElementNS('http://www.w3.org/2000/svg', 'polygon');
    poly.setAttribute('points', '48,0 24,41.6 -24,41.6 -48,0 -24,-41.6 24,-41.6');
    nut.appendChild(poly);
    hex.appendChild(nut);
    hex.appendChild(el('b', null, '-' + d.pc + '%'));
    well.appendChild(hex);

    var bell = el('button', 'llo-bell');
    bell.type = 'button';
    bell.setAttribute('data-bell', '');
    bell.setAttribute('aria-pressed', 'false');
    bell.setAttribute('data-name', name);
    bell.setAttribute('aria-label', 'Watch ' + name + ' for price drops and restocks');
    bell.appendChild(svg(I_BELL));
    well.appendChild(bell);

    if (d.q === 1 || d.q === 2) well.appendChild(el('span', 'llo-card__left', d.q === 1 ? 'Last one' : 'Only 2 left'));
    li.appendChild(well);

    var body = el('div', 'llo-card__body');
    var g = GAMES[d.g] || GAMES.other;
    var gl = el('span', 'llo-card__game', g.name);
    gl.style.setProperty('--g', g.color);
    body.appendChild(gl);
    var ttl = el('div', 'llo-card__ttl' + (set ? ' has-set' : ''));
    var na = el('a', 'llo-card__name', name);
    na.href = url;
    na.setAttribute('aria-label', d.t + ', ' + this.money(d.p) + ', ' + d.pc + '% off');
    ttl.appendChild(na);
    if (set) ttl.appendChild(el('span', 'llo-card__set', set));
    body.appendChild(ttl);

    var prices = el('p', 'llo-card__prices');
    prices.appendChild(el('b', null, this.money(d.p)));
    if (this.showWas) prices.appendChild(el('s', null, this.money(d.c)));
    body.appendChild(prices);
    if (this.showSave) body.appendChild(el('span', 'llo-card__save', 'Save ' + this.money(d.c - d.p)));

    var btn;
    if (d.n === 1 && d.a) {
      btn = el('button', 'llo-add');
      btn.type = 'button';
      btn.setAttribute('data-add', String(d.a));
      btn.appendChild(svg(I_BAG));
      btn.appendChild(el('span', null, 'Add to basket'));
    } else {
      btn = el('a', 'llo-add llo-add--ghost');
      btn.href = url;
      btn.appendChild(el('span', null, 'Choose options'));
    }
    body.appendChild(btn);
    li.appendChild(body);
    return li;
  };

  Offers.prototype.render = function (list, announce) {
    var rail = this.rail, self = this;
    var all = rail.querySelector('.llo-card--all');
    rail.textContent = '';
    list.forEach(function (d, i) {
      var c = self.card(d);
      c.style.setProperty('--n', i);
      rail.appendChild(c);
    });
    if (all) rail.appendChild(all);
    rail.scrollLeft = 0;
    this.paintBells();
    /* arrows() reads scrollWidth. Straight after replacing every card that read
       forced a synchronous layout of the whole page (~390 ms in PageSpeed), so
       it waits for the frame the browser was going to lay out anyway. */
    requestAnimationFrame(function () { self.arrows(); });
    this.shownNow = list.map(function (d) { return d.h; });
    if (this.vary) {
      var prev = ls.get('ll:shown', []);
      var merged = this.shownNow.concat(prev), seen = {}, out = [];
      merged.forEach(function (h) { if (h && !seen[h]) { seen[h] = 1; out.push(h); } });
      ls.set('ll:shown', out.slice(0, 60));
    }
    if (announce && this.status) this.status.textContent = announce;
    /* Every card above is a freshly created element, and a new element starts
       its CSS animation on its own. The old remove / read offsetWidth / add
       dance only forced a full-page reflow to get the same result. */
    rail.classList.add('is-dealt');
    if (this.live) this.verify(list.slice(0, 8));
  };

  /* --------------------------------------------------------------- filters */
  Offers.prototype.counts = function () {
    var c = {};
    this.pool.forEach(function (d) { c[d.g] = (c[d.g] || 0) + 1; });
    return c;
  };

  Offers.prototype.chips = function () {
    var box = this.chipsBox, self = this;
    if (!box) return;
    var c = this.counts();
    var items = [];
    var personalLabel = this.hasSignal() ? 'For you' : 'Top picks';
    items.push({ key: 'foryou', label: personalLabel });
    items.push({ key: 'best', label: 'Biggest savings' });
    Object.keys(c).filter(function (k) { return k !== 'other' && c[k] >= 2; })
      .sort(function (a, b) { return c[b] - c[a]; })
      .forEach(function (k) { items.push({ key: k, label: GAMES[k].name, n: c[k], color: GAMES[k].color }); });
    box.textContent = '';
    items.forEach(function (it) {
      var b = el('button', 'llo-chip');
      b.type = 'button';
      b.setAttribute('data-filter', it.key);
      b.setAttribute('aria-pressed', it.key === self.filter ? 'true' : 'false');
      if (it.color) b.style.setProperty('--g', it.color);
      if (it.key === 'foryou' && self.hasSignal()) b.appendChild(svg('M12 20.3 4.4 13A4.6 4.6 0 0 1 12 7.6a4.6 4.6 0 0 1 7.6 5.4Z', 'llo-chip__ico'));
      if (it.key === 'best') b.appendChild(svg('M3.6 12.2V4.8a1.2 1.2 0 0 1 1.2-1.2h7.4l8.2 8.2a1.7 1.7 0 0 1 0 2.4l-6 6a1.7 1.7 0 0 1-2.4 0Z|M8.1 6.6v.1', 'llo-chip__ico'));
      b.appendChild(el('span', null, it.label));
      if (it.n) b.appendChild(el('small', null, String(it.n)));
      box.appendChild(b);
    });
  };

  Offers.prototype.deck = function () {
    var c = {}, best = {}, self = this;
    this.pool.forEach(function (d) {
      c[d.g] = (c[d.g] || 0) + 1;
      if (d.pc > (best[d.g] || 0)) best[d.g] = d.pc;
    });
    var min = 10;
    this.deckCards.forEach(function (card) {
      var g = card.getAttribute('data-game');
      var n = c[g] || 0;
      var sub = card.querySelector('[data-deck-sub]');
      var save = card.querySelector('[data-deck-save]');
      card.classList.toggle('is-on', self.filter === g);
      if (n > 0) {
        card.setAttribute('data-filterable', '');
        card.setAttribute('role', 'button');
        /* aria-pressed only while it is a toggle button. On a plain link it is
           not a permitted attribute (Lighthouse aria-allowed-attr). */
        card.setAttribute('aria-pressed', self.filter === g ? 'true' : 'false');
        if (sub) sub.textContent = n + (n === 1 ? ' offer' : ' offers');
        if (save && best[g] >= min) { save.querySelector('b').textContent = best[g] + '%'; save.hidden = false; }
        /* No aria-label: the name is computed from what the card shows
           (kicker, game, "12 offers", "Up to 30%"). A hand-written label that
           left out the visible words failed WCAG 2.5.3 Label in Name, which
           breaks voice control ("click Explore Pokemon"). */
        card.removeAttribute('aria-label');
      } else {
        card.removeAttribute('data-filterable');
        card.removeAttribute('role');
        if (sub) sub.textContent = '';
        if (save) save.hidden = true;
        card.removeAttribute('aria-label');
        card.removeAttribute('aria-pressed');
      }
    });
  };

  Offers.prototype.setFilter = function (key, why) {
    this.filter = key;
    ss.set('llo:filter', key);
    var list = this.pick(key);
    var label = key === 'best' ? 'biggest savings' : GAMES[key] ? GAMES[key].name + ' offers' : (this.hasSignal() ? 'offers picked for you' : 'top picks');
    this.render(list, 'Showing ' + list.length + ' ' + label);
    var self = this;
    Array.prototype.forEach.call(this.chipsBox.querySelectorAll('[data-filter]'), function (b) {
      b.setAttribute('aria-pressed', b.getAttribute('data-filter') === key ? 'true' : 'false');
    });
    this.deck();
    this.footnote();
    if (why === 'user' && this.eye && this.eye.look) {
      var chip = this.chipsBox.querySelector('[data-filter="' + key + '"]');
      if (chip) { var r = chip.getBoundingClientRect(); this.eye.look(r.left + r.width / 2, r.top + r.height / 2, 1.2); }
    }
  };

  Offers.prototype.footnote = function () {
    if (!this.foot) return;
    if (!this.footDefault) this.footDefault = this.foot.textContent;
    var src = this.profile.sources, bits = [];
    if (src.watchlist) bits.push('your watchlist');
    if (src.orders) bits.push('your orders');
    if (src.basket) bits.push('your basket');
    if (src.viewed || src.offers) bits.push('what you have been looking at');
    if (this.filter === 'foryou' && bits.length) {
      var last = bits.pop();
      this.foot.textContent = 'Picked for you from ' + (bits.length ? bits.join(', ') + ' and ' + last : last) + '. Refreshed every day.';
    } else if (this.filter === 'best') {
      this.foot.textContent = 'The deepest discounts in the sale right now, biggest first.';
    } else if (GAMES[this.filter]) {
      this.foot.textContent = 'Every ' + GAMES[this.filter].name + ' offer in the sale, best matches first.';
    } else {
      this.foot.textContent = this.footDefault;
    }
  };

  Offers.prototype.headline = function () {
    var best = 0;
    this.pool.forEach(function (d) { if (d.pc > best) best = d.pc; });
    var n = this.root.querySelector('[data-upto-n]');
    var box = this.root.querySelector('[data-upto]');
    if (n && best > 0) { n.textContent = String(best); box.hidden = false; }
    var sub = this.root.querySelector('[data-cta-sub]');
    if (sub && this.full) sub.textContent = this.pool.length + ' live deals';
  };

  /* ------------------------------------------------------------- selection */
  Offers.prototype.select = function (li, loud) {
    if (!li || !li.getAttribute('data-h')) return;
    if (this.sel && this.sel !== li) this.sel.classList.remove('is-sel');
    this.sel = li;
    li.classList.add('is-sel');
    var d = this.byHandle[li.getAttribute('data-h')];
    if (!d || !this.eye || !this.eye.look) return;
    var r = li.getBoundingClientRect();
    this.eye.look(r.left + r.width / 2, r.top + r.height * 0.35, 1.8);
    if (d.pc >= this.hot) {
      var now = Date.now();
      if (!this.cheered[d.h] || now - this.cheered[d.h] > 12000) {
        this.cheered[d.h] = now;
        var lvl = Math.max(0.3, Math.min(1, (d.pc - this.hot) / Math.max(10, 75 - this.hot) + 0.3));
        if (this.eye.cheer) this.eye.cheer(loud ? 1 : lvl);
        li.classList.remove('is-cheer');
        void li.offsetWidth;
        li.classList.add('is-cheer');
      }
    }
  };

  /* ---------------------------------------------------------------- basket */
  Offers.prototype.add = function (btn) {
    var id = btn.getAttribute('data-add');
    var li = btn.closest('.llo-card');
    var d = li && this.byHandle[li.getAttribute('data-h')];
    if (!id || btn.disabled) return;
    btn.disabled = true;
    btn.classList.add('is-busy');
    var self = this;
    fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] })
    })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) {
        btn.classList.remove('is-busy');
        if (!res.ok) {
          btn.disabled = false;
          var msg = (res.j && (res.j.description || res.j.message)) || 'That could not be added.';
          if (/sold out|already|not available|quantity/i.test(msg)) {
            toast('That one has just gone. It was the last one.');
            if (li) li.classList.add('is-gone');
          } else toast(msg);
          return;
        }
        btn.classList.add('is-added');
        btn.lastChild.textContent = 'Added';
        btn.replaceChild(svg(I_TICK), btn.firstChild);
        if (self.eye && self.eye.cheer) self.eye.cheer(1);
        if (li) { li.classList.remove('is-cheer'); void li.offsetWidth; li.classList.add('is-cheer'); }
        toast((d ? (d.s && d.t.indexOf(' : ') > -1 ? d.t.split(' : ')[0] : d.t) : 'It') + ' is in your basket.', { text: 'View basket', href: '/cart' });
        try { document.dispatchEvent(new CustomEvent('ll:cart:updated', { detail: {} })); } catch (e) {}
        setTimeout(function () {
          btn.disabled = false;
          btn.classList.remove('is-added');
          btn.lastChild.textContent = 'Add another';
          btn.replaceChild(svg(I_BAG), btn.firstChild);
        }, 2600);
      })
      .catch(function () {
        btn.disabled = false;
        btn.classList.remove('is-busy');
        toast('Could not reach the basket. Please try again.');
      });
  };

  /* ------------------------------------------------------------- watchlist */
  Offers.prototype.paintBells = function () {
    var list = ls.get('ll_watchlist', null);
    if (Object.prototype.toString.call(list) !== '[object Array]') list = ls.get('ll_preorder_watch', []);
    var on = {};
    (list || []).forEach(function (h) { on[h] = 1; });
    Array.prototype.forEach.call(this.rail.querySelectorAll('[data-bell]'), function (b) {
      var h = b.closest('.llo-card').getAttribute('data-h');
      var w = !!on[h];
      b.setAttribute('aria-pressed', w ? 'true' : 'false');
      b.setAttribute('aria-label', (w ? 'Stop watching ' : 'Watch ') + (b.getAttribute('data-name') || 'this'));
    });
  };
  Offers.prototype.bell = function (b) {
    var h = b.closest('.llo-card').getAttribute('data-h');
    var list = ls.get('ll_watchlist', null);
    if (Object.prototype.toString.call(list) !== '[object Array]') list = ls.get('ll_preorder_watch', []);
    var i = list.indexOf(h), adding = i < 0;
    if (adding) list.unshift(h); else list.splice(i, 1);
    list = list.slice(0, 100);
    ls.set('ll_watchlist', list);
    ls.set('ll_preorder_watch', list);
    if (this.cid) ls.set('ll_watchlist_c_' + this.cid, list);
    try { document.dispatchEvent(new CustomEvent('ll:watchlist:change', { detail: { list: list } })); } catch (e) {}
    if (adding) {
      if (window.LLWatchlistLive && window.LLWatchlistLive.refresh) window.LLWatchlistLive.refresh();
      b.classList.remove('is-ring'); void b.offsetWidth; b.classList.add('is-ring');
    } else if (window.LLWatchlistLive && window.LLWatchlistLive.stop) window.LLWatchlistLive.stop(h);
    toast((b.getAttribute('data-name') || 'It') + (adding ? ' is on your watchlist. We will tell you if the price drops again.' : ' is off your watchlist.'), adding ? { text: 'Watchlist', href: '/pages/watchlist' } : null);
    this.paintBells();
  };

  /* ------------------------------------------------ live price and stock */
  Offers.prototype.verify = function (list) {
    var self = this;
    list.forEach(function (d) {
      if (d._checked) return;
      d._checked = 1;
      fetch('/products/' + d.h + '.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (p) {
          if (!p) return;
          var li = self.rail.querySelector('[data-h="' + d.h + '"]');
          if (!li) return;
          var v = (p.variants || []).filter(function (x) { return x.available; })[0];
          if (!p.available || !v) { li.classList.add('is-gone'); return; }
          if (v.price !== d.p || (v.compare_at_price || 0) !== d.c) {
            d.p = v.price; d.c = v.compare_at_price || 0; d.pc = pctOf(d);
            var b = li.querySelector('.llo-card__prices b'); if (b) b.textContent = self.money(d.p);
            var s = li.querySelector('.llo-card__prices s'); if (s) s.textContent = self.money(d.c);
            var hx = li.querySelector('.llo-hex b'); if (hx) hx.textContent = '-' + d.pc + '%';
            var sv = li.querySelector('.llo-card__save'); if (sv) sv.textContent = 'Save ' + self.money(d.c - d.p);
            if (!(d.c > d.p)) li.classList.add('is-gone');
          }
        })
        .catch(function () {});
    });
  };

  /* ---------------------------------------------------------- full feed */
  Offers.prototype.loadFeed = function () {
    if (this._feeding || this.full) return;
    this._feeding = true;
    var self = this, key = 'llo:feed:v2:' + this.feedUrl;
    var hit = ss.get(key);
    if (hit && Date.now() - hit.t < 15 * 60 * 1000 && hit.list && hit.list.length) { this.useFeed(hit.list); return; }
    var got = [];
    var page = function (n, tries) {
      var url = self.feedUrl + (self.feedUrl.indexOf('?') > -1 ? '&' : '?') + 'section_id=ll-deals-feed&page=' + n;
      return fetch(url, { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.text() : Promise.reject(r.status); })
        .then(function (html) {
          var m = /data-pages="(\d+)"[^>]*>([\s\S]*?)<\/script>/.exec(html);
          if (!m) return 0;
          got = got.concat(JSON.parse(m[2]));
          return parseInt(m[1], 10) || 1;
        })
        .catch(function (err) {
          /* A busy moment on the storefront should not cost the shopper the full list. */
          if ((tries || 0) >= 2) throw err;
          return new Promise(function (res) { setTimeout(res, 900 * ((tries || 0) + 1)); })
            .then(function () { return page(n, (tries || 0) + 1); });
        });
    };
    page(1).then(function (pages) {
      var rest = [];
      for (var i = 2; i <= Math.min(pages, 6); i++) rest.push(page(i));
      return Promise.all(rest);
    }).then(function () {
      if (!got.length) { self._feeding = false; return; }
      ss.set(key, { t: Date.now(), list: got });
      self.useFeed(got);
    }).catch(function () { self._feeding = false; });
  };

  Offers.prototype.useFeed = function (list) {
    this.full = true;
    this.setPool(list);
    this.buildProfile();
    this.chips();
    this.deck();
    this.headline();
    /* Swap the row only if nobody has started using it yet. */
    if (!this.touched) this.setFilter(this.filter, 'feed');
    else this.footnote();
  };

  /* ------------------------------------------------------------ plumbing */
  Offers.prototype.arrows = function () {
    var p = this.root.querySelector('[data-prev]'), n = this.root.querySelector('[data-next]'), r = this.rail;
    if (!p || !n) return;
    var max = r.scrollWidth - r.clientWidth - 2;
    p.disabled = r.scrollLeft <= 2;
    n.disabled = r.scrollLeft >= max;
  };

  Offers.prototype.bind = function () {
    var self = this, root = this.root, rail = this.rail;
    var step = function () {
      var c = rail.querySelector('.llo-card');
      var w = c ? c.getBoundingClientRect().width + 14 : 240;
      return Math.max(w, Math.floor(rail.clientWidth / w) * w);
    };
    var prev = root.querySelector('[data-prev]'), next = root.querySelector('[data-next]');
    if (prev) prev.addEventListener('click', function () { self.touched = true; rail.scrollBy({ left: -step(), behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { self.touched = true; rail.scrollBy({ left: step(), behavior: 'smooth' }); });

    var settle = 0;
    rail.addEventListener('scroll', function () {
      self.arrows();
      clearTimeout(settle);
      settle = setTimeout(function () {
        if (!window.matchMedia('(hover: none)').matches) return;
        /* Touch: whichever card has come to rest at the start of the row is the pick. */
        var rr = rail.getBoundingClientRect(), best = null, bd = 1e9;
        Array.prototype.forEach.call(rail.querySelectorAll('.llo-card[data-h]'), function (c) {
          var d = Math.abs(c.getBoundingClientRect().left - rr.left - 12);
          if (d < bd) { bd = d; best = c; }
        });
        if (best) self.select(best);
      }, 160);
    }, { passive: true });
    rail.addEventListener('touchstart', function () { self.touched = true; }, { passive: true });
    rail.addEventListener('wheel', function () { self.touched = true; }, { passive: true });

    var hoverT = 0;
    rail.addEventListener('pointerover', function (e) {
      if (e.pointerType !== 'mouse') return;
      var li = e.target.closest && e.target.closest('.llo-card[data-h]');
      if (!li || li === self.sel) return;
      clearTimeout(hoverT);
      hoverT = setTimeout(function () { self.select(li); }, 110);
    });
    rail.addEventListener('focusin', function (e) {
      var li = e.target.closest && e.target.closest('.llo-card[data-h]');
      if (li) self.select(li);
    });

    root.addEventListener('click', function (e) {
      var t = e.target;
      if (!t.closest) return;
      var chip = t.closest('[data-filter]');
      if (chip) { self.touched = false; self.setFilter(chip.getAttribute('data-filter'), 'user'); return; }
      var deck = t.closest('.llo-deck__card[data-filterable]');
      if (deck && !e.metaKey && !e.ctrlKey && !e.shiftKey) {
        e.preventDefault();
        self.touched = false;
        self.setFilter(deck.getAttribute('data-game'), 'user');
        var r = rail.getBoundingClientRect();
        if (r.top > window.innerHeight - 120 || r.bottom < 80) rail.scrollIntoView({ behavior: 'smooth', block: 'center' });
        return;
      }
      var add = t.closest('[data-add]');
      if (add) { e.preventDefault(); self.touched = true; self.add(add); return; }
      var bell = t.closest('[data-bell]');
      if (bell) { e.preventDefault(); self.touched = true; self.bell(bell); return; }
      var link = t.closest('.llo-card a');
      var li = link && link.closest('.llo-card[data-h]');
      if (li) {
        var d = self.byHandle[li.getAttribute('data-h')];
        if (d) {
          var v = ls.get('ll:viewed', []).filter(function (x) { return x.h !== d.h; });
          v.unshift({ v: d.v, t: d.y, p: d.p, h: d.h, ts: Date.now() });
          ls.set('ll:viewed', v.slice(0, 40));
        }
      }
    });

    document.addEventListener('ll:watchlist:change', function () { self.paintBells(); });
    window.addEventListener('storage', function (e) { if (!e.key || e.key === 'll_watchlist') self.paintBells(); });
    window.addEventListener('resize', function () { self.arrows(); }, { passive: true });

    /* Fetch the whole sale shortly before the section is on screen. */
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (es) {
        if (es.some(function (x) { return x.isIntersecting; })) { io.disconnect(); self.loadFeed(); }
      }, { rootMargin: '1400px 0px' });
      io.observe(root);
    } else this.loadFeed();
    setTimeout(function () { self.loadFeed(); }, 4000);
    setTimeout(function () { self.loadFeed(); }, 12000);
  };

  Offers.prototype.clock = function () {
    var box = this.root.querySelector('[data-clock]'), out = this.root.querySelector('[data-clock-t]');
    var self = this, key = new Date().toDateString();
    if (!box || !out || this.root.dataset.countdown !== 'true' || !this.rotate) return;
    box.hidden = false;
    var pad = function (n) { return (n < 10 ? '0' : '') + n; };
    var tick = function () {
      var now = new Date();
      var mid = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1);
      var s = Math.max(0, Math.floor((mid - now) / 1000));
      out.textContent = pad(Math.floor(s / 3600)) + ':' + pad(Math.floor(s % 3600 / 60)) + ':' + pad(s % 60);
      if (now.toDateString() !== key) {
        key = now.toDateString();
        self.pool.forEach(function (d) { d._checked = 0; });
        self.setFilter(self.filter, 'midnight');
        if (self.eye && self.eye.surprise) self.eye.surprise();
        toast('Fresh picks are in for today.');
      }
    };
    tick();
    setInterval(tick, 1000);
  };

  Offers.prototype.boot = function () {
    var saved = ss.get('llo:filter');
    var start = saved && (saved === 'best' || saved === 'foryou' || GAMES[saved]) ? saved : 'foryou';
    this.filter = start;
    this.chips();
    this.deck();
    this.headline();
    this.setFilter(start, 'boot');
    this.clock();
    /* The basket's view of the shopper, added once it answers. */
    var self = this;
    if (this.personal) {
      fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (c) {
          self.basket = c.items || [];
          if (!self.basket.length) return;
          self.buildProfile();
          if (!self.touched) { self.chips(); self.setFilter(self.filter, 'basket'); }
        })
        .catch(function () {});
    }
  };

  var start = function () {
    Array.prototype.forEach.call(document.querySelectorAll('[data-ll-offers]'), function (root) {
      if (root.__llo) return;
      root.__llo = new Offers(root);
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
  document.addEventListener('shopify:section:load', start);
}());
